// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__210Bn","select":"Header_select__1kIkP","clinic":"Header_clinic__2YG9J"};